import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, Trash2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";

const DURS = [30, 60, 120];

export default function PricingTab() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/setups").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (s) => {
    try {
      await api.put(`/admin/setups/${s.id}`, {
        name: s.name, station_type: s.station_type, desc: s.desc,
        enabled: s.enabled, order: s.order, prices: s.prices,
      });
      toast.success("Pricing saved");
    } catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => { try { await api.delete(`/admin/setups/${id}`); toast.success("Setup removed"); load(); } catch (e) { toast.error(apiError(e)); } };
  const addNew = async () => {
    try { await api.post("/admin/setups", { name: "New Setup", station_type: "ps5", desc: "", enabled: true, order: (items?.length || 0) + 1, prices: { "30": 0, "60": 0, "120": 0 } }); toast.success("Setup added"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const update = (id, patch) => setItems((prev) => prev.map((s) => s.id === id ? { ...s, ...patch } : s));
  const updatePrice = (id, dur, val) => setItems((prev) => prev.map((s) => s.id === id ? { ...s, prices: { ...s.prices, [dur]: Number(val) || 0 } } : s));

  if (!items) return <Loader2 className="animate-spin text-purple-400" />;
  return (
    <div>
      <Button data-testid="add-setup-btn" onClick={addNew} className="mb-4 bg-purple-600 hover:bg-purple-500"><Plus size={16} /> Add Gaming Setup</Button>
      <div className="space-y-4">
        {items.map((s) => (
          <div key={s.id} className="glass rounded-2xl p-4" data-testid={`setup-${s.id}`}>
            <div className="flex flex-wrap gap-3 items-center mb-3">
              <Input value={s.name} onChange={(e) => update(s.id, { name: e.target.value })} className="flex-1 min-w-[160px] h-10 bg-purple-950/30 border-purple-500/30 font-semibold" />
              <select value={s.station_type} onChange={(e) => update(s.id, { station_type: e.target.value })} className="h-10 rounded-xl bg-purple-950/40 border border-purple-500/30 px-3 text-sm">
                <option value="ps5">PS5</option><option value="pc">PC</option>
              </select>
              <label className="flex items-center gap-2 text-sm text-slate-400">
                <input type="checkbox" checked={s.enabled} onChange={(e) => update(s.id, { enabled: e.target.checked })} /> Enabled
              </label>
            </div>
            <Input value={s.desc} onChange={(e) => update(s.id, { desc: e.target.value })} placeholder="Description" className="h-10 bg-purple-950/30 border-purple-500/30 mb-3 text-sm" />
            <div className="grid grid-cols-3 gap-3">
              {DURS.map((d) => (
                <div key={d}>
                  <label className="text-xs text-purple-400 font-mono">{d === 30 ? "30 Min" : d === 60 ? "1 Hour" : "2 Hours"} (₹)</label>
                  <Input type="number" value={s.prices[String(d)] ?? 0} onChange={(e) => updatePrice(s.id, String(d), e.target.value)} className="mt-1 h-10 bg-purple-950/30 border-purple-500/30" data-testid={`price-${s.id}-${d}`} />
                </div>
              ))}
            </div>
            <div className="flex gap-2 mt-3">
              <Button size="sm" onClick={() => save(s)} data-testid={`save-setup-${s.id}`} className="h-9 bg-emerald-600 hover:bg-emerald-500"><Save size={14} /> Save</Button>
              <Button size="sm" variant="outline" onClick={() => del(s.id)} className="h-9 border-red-500/30 bg-transparent text-red-300"><Trash2 size={14} /> Remove</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
